import { useState, useEffect } from "react";

const CETClock = () => {
    const [time, setTime] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 430);

    // Update the time every second
    useEffect(() => {
        const updateTime = () => {
            const currentTime = new Date().toLocaleString("en-US", {
                timeZone: "Europe/Berlin",
                hour12: true,
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h12",
            });
            setTime(currentTime);
        };

        updateTime(); // Set immediately on mount
        const intervalId = setInterval(updateTime, 1000);
        return () => clearInterval(intervalId);
    }, []);

    // Track window resize
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 430);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const timeTextStyle = {
        color: "var(--primary-color)",
        textAlign: "justify",
        flexShrink: "0",
        fontFamily: "Clash Display, sans-serif",
        fontSize: isMobile ? "9.487svw" : "2.6042svw",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "normal",
    };

    return <p style={timeTextStyle}>{time}</p>;
};

export default CETClock;
